<template>
  <div class="full-sand" v-if="visible" @click.prevent="handleClick">
    <div ref="sandBoxFull" class="sand-box-tour-base-zmin">
      <ImageDrawer
        mode="tour"
        v-on:sandTableZoomIn="sandTableZoomIn"
        :isShowZoom="true"
        :showZoomOut="true"
        :visible="true"
      ></ImageDrawer>
    </div>
  </div>
</template>

<script>
import ImageDrawer from "@/components/ImageDrawer";
import { mapGetters } from "vuex";
import { handleImageSize } from "../../static/js/utils/tools";

export default {
  components: { ImageDrawer },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["editSandtable"]),
  },
  watch: {
    visible(value) {
      if (value) {
        // this.getImageWH();
      }
    },
  },
  data() {
    return {
      imageWidth: 0,
      imageHeight: 0,
      isShowImage: false,
    };
  },
  methods: {
    getImageWH() {
      const imgWH = {};
      let img = new Image();
      img.src = this.editSandtable.url;
      img.onload = () => {
        this.imageWidth = img.width;
        this.imageHeight = img.height;
        // this.controlSize();
      };
      img.οnerrοr = function () {
        // this.controlSize();
      };
    },
    sandTableZoomIn(isZoomIn) {
      if (!isZoomIn) {
        this.isShowImage = false;
        this.$parent.sandTableZoomIn(false);
        this.$emit("closeFull");
      }
    },
    handleClick(event) {
      if (event.target === this.$el) {
        this.sandTableZoomIn(false);
      }
    },
    // 沙盤的放大和縮小
    // controlSize() {
    //   const gap = 80;
    //   const element = this.$refs.sandBoxFull;
    //   const ratio = this.imageHeight === 0 ? 0 : this.imageWidth / this.imageHeight;
    //   const width = document.documentElement.clientWidth || document.body.clientWidth;
    //   const height = document.documentElement.clientHeight || document.body.clientHeight;
    //   if (ratio === 0) {
    //     element.style.height = height - gap + "px";
    //   } else if (ratio > 1) {
    //     console.log("width=", width);
    //     element.style.width = this.$isMobile()
    //       ? width + "px"
    //       : height * 0.8 + "px";
    //   } else if (ratio < 1) {
    //     console.log("height=", height);
    //     element.style.height = height - gap + "px";
    //     element.style.width = ratio * (height - gap) + "px";
    //   } else if (ratio === 1) {
    //     element.style.height = element.style.width = this.$isMobile()
    //       ? width + "px"
    //       : height * 0.8 + "px";
    //   }
    //   this.isShowImage = true;
    // },
  },
};
</script>

<style lang="less" scoped>
.full-sand {
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: 3000;
  background: rgba(0, 0, 0, 0.7);
  .sand-box-tour-base-zmin-m {
    position: absolute;
    top: 50%;
    // right: 0px;
    left: 0px;
    transform: translate(0, -50%);
    padding: 0; /*10px;*/
    background-color: rgba(255, 255, 255, 0.4);
    z-index: 998;
  }
  .sand-box-tour-base-zmin {
    position: absolute;
    top: 50%;
    padding: 0; /*10px;*/
    background-color: rgba(255, 255, 255, 0.4);
    z-index: 998;
    transform: translate(-50%, -50%);
    left: 50%;
  }
}
</style>
